import { render, staticRenderFns } from "./Company_recruitments.vue?vue&type=template&id=0cf46ea1&scoped=true&lang=pug&"
import script from "./Company_recruitments.vue?vue&type=script&lang=coffee&"
export * from "./Company_recruitments.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf46ea1",
  null
  
)

export default component.exports